import { EditIcon, MailIcon, PlusIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { SectionHeader } from "@vega-core/components/Layout/SectionHeader";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";

import { DetailRow } from "../../components/DetailRow";

import { EditActionModal } from "./EditActionModal";

export const EmailAddresses = () => {
  const { data: profile } = useUserProfile();
  const isOpen = useBoolean(false);

  if (!profile) {
    return null;
  }
  const secondaryEmail = profile.secondaryContactEmail;

  return (
    <>
      <EditActionModal open={isOpen.value} setOpen={isOpen.setValue} />

      <div className="flex flex-col">
        <SectionHeader
          icon={<MailIcon />}
          showIconBackground={false}
          title={m.formFields_email()}
        />
        <div className="flex flex-col items-start pl-0 md:pl-13">
          <DetailRow isLocked label={m.common_email1()} value={profile.email} />
          {secondaryEmail ? (
            <DetailRow
              action={
                <ThemedIconButton
                  ariaLabel="edit secondary address"
                  dataTestId="edit-secondary-email"
                  icon={<EditIcon />}
                  onClick={isOpen.setTrue}
                  variant="noBackground"
                />
              }
              label={m.settings_secondaryEmail()}
              value={secondaryEmail}
            />
          ) : (
            <div className="flex w-full justify-end py-3">
              <ThemedButton
                dataTestId="add-email-button"
                icon={<PlusIcon />}
                iconPosition="left"
                onClick={isOpen.setTrue}
                variant="text"
              >
                {m.settings_addSecondaryEmail()}
              </ThemedButton>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

import { useUserProfile } from "@vega-api/extended/auth/hooks";
